module.exports = __webpack_public_path__ + "static/img/ewm.42f04885.jpeg";